import { Assessment } from "@mui/icons-material";


const routes = {
  login: '/login',
  register: '/register',
  otp: '/otp',
  verified: '/otpverification',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',
  home: '/home',
  learn: '/learn',
  stepper:'/stepper/:step',
  part1: '/part1',
  part2: '/part2',
  part3: '/part3',
  part4: '/part4',
  postJob: '/jobs/post-job',
  appliedJobs: '/jobs/appliedJobs',
  savedJobs: '/jobs/savedJobs',
  myJobs: '/jobs/myJobs',
  resumeLibrary: '/jobs/Resume-library',
  resumeBuilder: '/jobs/Resume-builder',
  mentorship: '/mentorship',
  setupPreference: '/mentorship/Set-up-your-preferences',
  mentorDetails: '/mentorship/Mentee-Details',
  fundraise: '/fundraise',
  fundraiseDetails: '/fundraise',
  groups: '/groups',
  discoverGroups: '/groups/discover-groups',
  yourGroups: '/groups/Your-groups',
  createGroup: '/groups/create-group',
  network: '/network',
  survey: '/survey',
  yoursurvey: '/survey/yoursurvey',
  createSurvey: '/survey/create-survey',
  test: '/test',
  service: '/Service & Support',
  serviceFAQ: '/service & support/FAQ',
  RequestService: '/service & support/RequestService',
  Answers: '/service & support/RequestService',
  TicketPreview: '/service & support/Ticket-Preview',
  settings: '/settings',
  schedule: '/calendar',
  socialLinks: '/socialLinks',
  academics: '/academics',
  academicsElaborate: '/academicsElaborate',
  resourceUpload: '/resourceUpload',
  myStudents: '/My Students',
  courseElaborate: '/course-elaborate',
  attendance: '/attendance',
  mySchedule: '/My Schedule',
  studentDetails: '/My Students/Student Details/:id',
  studentInfo: '/My Students/Student Details/Student Info/:CourseOfferingID/:contactId',
  resourceEloboarate: '/resource-elaborate',
  attendanceTabs: '/attendance/Faculty Courses/Session Attendance/:id',
  facultyCourses: '/attendance/Faculty Courses',
  overAllAttendance: '/attendance/over All Attendance',
  EditProfile: '/editProfile',
  AssessmentAdding: '/Assessment',
  AssignmentAdding: '/Assignment',
  ForumAdding: '/Forum',
  AssignmentReview: '/AssignmentReview',
  ForumDiscussion: '/ForumDiscussion', 
  QuestionBank:'/QuestionBank'
};


export default routes;
